module.exports = {
    "api" : "https://boletosencopel.encopelrolamentos.com.br:3071",
    "site" : "http://encopelx.no-ip.biz:3070",
    //"api" : "http://jboss.ddns.me:3005",
    //"api" : "http://localhost:3005",
    //"site" : "http://localhost:3070",

   "corPrincipal" : "#e22128",
   //"corPrincipal" : "#000080",
    "txtFocused": "#000000",
    "tableHeadColor":"#000000",
}